import _ from 'lodash';
import { DateTime, Time, UTCDate } from '@skyjs/date';

export default v =>
  !_.isNil(v) &&
  !_.isArray(v) &&
  !_.isDate(v) &&
  !_.isFunction(v) &&
  _.isObject(v) &&
  !(v instanceof DateTime) &&
  !(v instanceof UTCDate) &&
  !(v instanceof Time);
